export const SELECT_SUKHAPABDEKDEE_PLAN = 'SELECT_SUKHAPABDEKDEE_PLAN'

export const selectSukhapabDekDeePlan = (planCode) => ({
  type: SELECT_SUKHAPABDEKDEE_PLAN,
  payload: planCode,
})

export const EDIT_CAMPAIGN_PLAN = 'EDIT_CAMPAIGN_PLAN'

export const editCampaignPlan = (displayProducts) => ({
  type: EDIT_CAMPAIGN_PLAN,
  payload: displayProducts,
})
